import * as Auth from '@/utils/auth';
import * as Utils from '@/utils/index';
import * as firebase from 'firebase/app';
import store from './store';
import 'firebase/messaging';
firebase.initializeApp(Utils.FirebaseConfig);
const isIOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
let messaging = null;



if (!isIOS) messaging = firebase.messaging();

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('./static/service-worker.js')
    .then(reg => {
      if (!messaging) return;
      console.log('Registered service worker'); 
      messaging.useServiceWorker(reg);
      initializePushNotification();

      messaging.onMessage(payload => {
        console.log('mounted -> payload', payload);
        reg.showNotification(payload.notification.title, {
          body: payload.notification.body,
          icon: './static/icon-48x48.png',
          vibrate: [300, 100, 400]
        });
      });
    }).catch(err => {
      console.log('Register service worker failed', err);
    });
}


export function initializePushNotification () {

  let tokenId = Auth.getNotificationToken();

  if (!Notification) {
    alert('Desktop notifications not available in your browser. Try Chromium.');
    return;
  }
  if (!tokenId) {
    if (Notification.permission === 'granted') {
      messaging.getToken().then(token => {
        Auth.setNotificationToken(token);
        
        registerFirebaseToken(token);
        console.log('initializePushNotification -> token', token);
      }).catch(err => console.log('Denied', err));
    }
    else {
      messaging
        .requestPermission()
        .then(res => messaging.getToken())
        .then(token => {
          Auth.setNotificationToken(token);
          
          console.log('initializePushNotification -> token', token);
          registerFirebaseToken(token);
        }).catch(err => console.log('Denied', err));
    }
  } else {
    registerFirebaseToken(tokenId);
  }
}

export function registerFirebaseToken (token) {
  if (window.location.hash.includes('/login')) return;
  store
    .dispatch('registerFirebaseToken', token)
    .then(res => {
      console.log('initializePushNotification -> res', res);
    })
    .catch(e => {
      console.log('initializePushNotification -> e', e);
    });
}


// WEBPACK FOOTER //
// ./src/register-service-worker.js